var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dropdown-notification", {}, [
    _c(
      "div",
      {
        attrs: { slot: "fa-icon" },
        on: { click: _vm.verOrdenesTrabajo },
        slot: "fa-icon"
      },
      [
        _c("i", {
          staticClass: "fa fa-first-order",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "badge-warning", attrs: { id: "ordenesTrabajo" } },
          [_vm._v(_vm._s(_vm.ordenesTrabajo))]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f6dae8e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6dae8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/NotificacionesOt.vue
// module id = 601
// module chunks = 0